import React from 'react';
import { useTranslation } from 'react-i18next';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PeopleIcon from '@mui/icons-material/People';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from 'components/common/Tooltip/Tooltip';
import Badge from '@mui/material/Badge';
import { makeStyles } from '@material-ui/core/styles';

import { useViewport } from 'utils/getViewport/getViewport';
import { SidebarViews } from 'utils/constants';
import './AssessmentNavBarIcons.scss';

const useStyles = makeStyles(() => ({
  badge: {
    fontSize: 5
  }
}));

export const AssessmentNavBarIcons = props => {
  const { t } = useTranslation();
  const { isMobile } = useViewport();
  const { sidebarView, onIconClick, filterVariables, activeUsers } = props;
  const classes = useStyles();

  const filterCount = filterVariables
    ? Number(filterVariables.required === 'true') +
      Number(!!filterVariables.answered) +
      Number(filterVariables.unassigned === 'true') +
      (filterVariables.assignees ? filterVariables.assignees.length : 0)
    : 0;
  const activeUsersCount = activeUsers && activeUsers.length > 1 ? activeUsers.length : 0;

  return (
    <div className={`assessment-navbar-icons ${isMobile ? 'mobile-icon-group' : 'icon-group'}`}>
      {isMobile && (
        <div className={`icon ${sidebarView === SidebarViews.SECTIONS ? 'icon-clicked' : ''}`} onClick={() => onIconClick(SidebarViews.SECTIONS)}>
          <FormatListBulleted />
        </div>
      )}
      <div className={`icon ${sidebarView === SidebarViews.FILTERS ? 'icon-clicked' : ''}`} onClick={() => onIconClick(SidebarViews.FILTERS)}>
        <Tooltip title={t('assessment.navBar.tooltip.filters')}>
          <Badge overlap="circular" badgeContent={filterCount} color="primary" classes={{ badge: classes.badge }}>
            <FilterAltIcon />
          </Badge>
        </Tooltip>
      </div>
      <div
        className={`icon ${sidebarView === SidebarViews.PARTICIPANT_DETAILS ? 'icon-clicked' : ''}`}
        onClick={() => onIconClick(SidebarViews.PARTICIPANT_DETAILS)}
      >
        <Tooltip title={t('assessment.navBar.tooltip.participants')}>
          <Badge overlap="circular" badgeContent={activeUsersCount} color="primary" classes={{ badge: classes.badge }}>
            <PeopleIcon />
          </Badge>
        </Tooltip>
      </div>
      <div className={`icon ${sidebarView === SidebarViews.OVERVIEW ? 'icon-clicked' : ''}`} onClick={() => onIconClick(SidebarViews.OVERVIEW)}>
        <Tooltip title={t('assessment.navBar.tooltip.info')}>
          <InfoOutlinedIcon />
        </Tooltip>
      </div>
    </div>
  );
};
